const Col = ({ title, rows, render, testid }) => (
  <div data-testid={testid}>
    <div className="mb-3 text-sm font-medium">{title}</div>
    {rows.map((r, i) => <div key={i} className="border-b border-[var(--line)] py-2 text-sm">{render(r)}</div>)}
    {!rows.length && <p className="text-sm text-[var(--stone-dark)]/60">—</p>}
  </div>
);

export const Package = ({ pkg, onRetry }) => !pkg ? (
  <section data-testid="package-section">
    <div className="eyebrow mb-2">Renovation package</div>
    <p className="font-display text-2xl" data-testid="package-failed">Package didn&apos;t finish.</p>
    <button className="btn-ghost mt-3" onClick={onRetry} data-testid="package-retry-button">Try again</button>
  </section>
) : (
  <section data-testid="package-section">
    <div className="eyebrow mb-1">Renovation package</div>
    <p className="mb-6 text-xs text-[var(--stone-dark)]">AI and rule check — not professionally verified. Get professional quotes before any work.</p>
    <div className="grid gap-8 md:grid-cols-3">
      <Col title={`Verified product prices · $${pkg.verifiedTotal.toLocaleString()}`} rows={pkg.columns["Verified prices"]} testid="package-verified"
        render={(r) => <><span>{r.name}</span><span className="float-right">${r.amount.toLocaleString()} product</span><span className="block text-xs text-[var(--stone-dark)]" data-testid="package-verified-install-note">Installation: quote required</span></>} />
      <Col title="Estimates" rows={pkg.columns.Estimates} testid="package-estimates"
        render={(r) => <><span>{r.name}</span><span className="block text-xs text-[var(--stone-dark)]">{r.range} · {r.basis}</span></>} />
      <Col title="Professional quotes" rows={pkg.columns["Professional quotes"]} testid="package-quotes"
        render={(r) => <><span>{r.name}</span><span className="float-right text-xs text-[var(--stone-dark)]">{r.label}</span></>} />
    </div>
    <div className="mt-8 grid gap-8 md:grid-cols-2">
      <div data-testid="package-bom">
        <div className="mb-3 text-sm font-medium">Bill of materials</div>
        {pkg.billOfMaterials.map((b, i) => (
          <div key={i} className="flex justify-between gap-3 border-b border-[var(--line)] py-2 text-sm">{b.product ? <a href={`#shop-${b.product.id}`} className="underline-offset-4 hover:underline" data-testid={`bom-link-${i}`}>{b.name}</a> : <span>{b.name}</span>}<span className="text-[var(--stone-dark)]">{b.quantity}</span></div>
        ))}
      </div>
      <div>
        <div className="mb-3 text-sm font-medium">Labor categories</div>
        <div className="flex flex-wrap gap-2" data-testid="package-labor">{pkg.laborCategories.map((l) => <span key={l} className="rounded-full border border-[var(--line)] px-3 py-1 text-xs">{l}</span>)}</div>
        {pkg.verificationRequirements?.length > 0 && (
          <div className="mt-5" data-testid="package-verification">
            <div className="mb-2 text-sm font-medium">Professional verification requirements</div>
            <ul className="grid gap-1">{pkg.verificationRequirements.map((v, i) => <li key={i} className="text-sm text-[var(--stone-dark)]">— {v}</li>)}</ul>
          </div>
        )}
        {pkg.missingMeasurements.length > 0 && (
          <div className="mt-5" data-testid="package-missing">
            <div className="mb-2 text-sm font-medium">Missing measurements</div>
            {pkg.missingMeasurements.map((m, i) => <p key={i} className="text-sm text-[var(--stone-dark)]">Needs measurement: {m.label || m.name || m}</p>)}
          </div>
        )}
      </div>
    </div>
  </section>
);
